const users = {
	title: "Users",
	new_user: "New User",
	edit_user: "Edit User: {name}",
	edit_role: "Edit Role: {name}",
	view_user: "View User: {name}",
	person_title: "User Details",
	list_title: "List of Users",
	list_subtitle: "Manage users",
	details_title: "User Details",
	account_title: "Account Details",
	address_title: "Address Details",
	organisation_title: "Organisation Details",
	id: "ID",
	first_name: "First Name",
	last_name: "Last Name",
	middle_name: "Middle Name",
	mobile: "Mobile Phone",
	status: "Status",
	email: "Email Address",
	password: "Password",
	search_organisations: "Search for Organisations...",
	profile: "Profile",
	changepass: "Change Password",
	course_types_and_group: "Course types and groups",
	is_instructor: "Is instructor role?",
	edit: {
		password_no_match: "Password does not match",
		personal_info: "Personal Information",
		old_pass: "Current Password",
		new_pass: "New Password",
		confirm_pass: "Confirm Password",
		password_success: "Password Successfully Updated.",
		password_error: "Changing of password not success. The entered old password doesn't match in our records!",
	},
};
export default users;